import { render } from "./VabeneAddNotificationPage.vue?vue&type=template&id=2a10e5e0&ts=true"
import script from "./VabeneAddNotificationPage.vue?vue&type=script&lang=ts"
export * from "./VabeneAddNotificationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__